import React from 'react'

import ContactCard from '../../../react4xp/components/ContactCard'

function ContactCardPart({ image, name, position, phone, email }) {
    let links: { text: string, href: string }[] = []

    if (phone) {
        links.push({
            text: phone,
            href: `tel:${phone}`,
        })
    }

    if (email) {
        links.push({
            text: email,
            href: `mailto:${email}`,
        })
    }

    return (
        <ContactCard
            section={{
                bgColor: 'white'
            }}
            image={{
                src: image?.link,
                redOutline: true,
                alt: image?.alt
            }}
            title={name}
            position={position}
            links={links}
        />
    )
}

export default (props) => <ContactCardPart {...props} />
